'use strict';

var CompFaresChartWrapperController = function CompFaresChartWrapperController($scope, $timeout, competitorFaresChartFormattersService, competitorFaresChartDataProviderService, constants) {
  function getFilterMode() {
    return $scope.contextData.compFares.filter.mode;
  }
  $scope.selectedServices = [];
  $scope.chartFormatters = competitorFaresChartFormattersService.getChartFormatters(getFilterMode);
  $scope.chartFormatters.tooltipFormatter.cssClass = 'competitor-fares-chart-tooltip ' + $scope.mode;
  $scope.contextData.compFares = {
    mode: constants.CABIN_DEEP_MODE,
    chartData: {
      isLegendCollapsible: false,
      legendItems: []
    },
    legendFilter: [],
    filter: {
      mode: null,
      stops: 'all',
      display: $scope.contextData.screen === constants.FLIGHT_SCREEN ? 'timeWindowCompFares' : 'lowestCompFares',
      matchType: {
        fare: false,
        time: false
      }
    }
  };
  $scope.reloadChart = function (ignoreLegend) {
    // reset profile chart data, so it will be refreshed when navigating between Profile Chart and Comp Fares Chart
    $scope.contextData.chartData = null;
    return competitorFaresChartDataProviderService.getData({
      screen: $scope.contextData.screen,
      mode: $scope.contextData.compFares.mode,
      filter: $scope.contextData.compFares.filter,
      legendFilter: $scope.contextData.compFares.legendFilter,
      selectedEntity: $scope.contextData.primaryEntity,
      selectedServices: $scope.selectedServices,
      reorderCarriers: false
    }).then(function (chartData) {
      $scope.contextData.compFares.chartData.data = chartData.data;
      $scope.contextData.compFares.chartData.verticalLineData = chartData.verticalLineData;
      $scope.contextData.compFares.chartData.timeWindowLabel = chartData.timeWindowLabel;
      if (!ignoreLegend) {
        $scope.contextData.compFares.chartData.legendItems = chartData.legendItems;
        $scope.contextData.compFares.chartData.isLegendCollapsible = chartData.isLegendCollapsible;
      }
    });
  };
  $scope.$watch('contextData.sidebar.visible', function (newValue) {
    $timeout(function () {
      $scope.contextData.compFares.chartData.isSidebarVisible = newValue;
    }, 0);
  });
  $scope.$watchCollection('contextData.compFares.legendFilter', function () {
    $timeout(function () {
      $scope.reloadChart(true);
    }, 0);
  });
  $scope.$watchGroup(['contextData.compFares.filter.display', 'contextData.compFares.filter.matchType.time', 'contextData.compFares.filter.matchType.fare', 'contextData.primaryEntity.flightDepartureDate', 'contextData.primaryEntity.leg', 'contextData.selectedMetric.id'], function () {
    $timeout(function () {
      $scope.contextData.compFares.legendFilter = [];
      $scope.reloadChart();
    }, 0);
  });
};
CompFaresChartWrapperController.$inject = ['$scope', '$timeout', 'CompetitorFaresChartFormattersService', 'CompetitorFaresChartDataProviderService', 'DataRetrieverConstantsService'];
module.exports = CompFaresChartWrapperController;